/**
 * 라우팅/메뉴 관련 상수 정의
 * 메뉴, 서브메뉴 값 등을 중앙에서 관리
 */

// ============================================
// 메뉴 값
// ============================================
export const MENU_VALUES = {
  CUSTOMERS: 'customers',
  SERVICES: 'services',
  SETTINGS: 'settings',
} as const;

// ============================================
// 서브메뉴 값
// ============================================
export const SUBMENU_VALUES = {
  USER_MANAGEMENT: 'user-management',
  USER_MANAGEMENT_ALL: 'user-management-all',
  CUSTOMER_MANAGEMENT: 'customer-management',
  SERVICE_USAGE: 'service-usage',
  ACTIVITY_LOGS: 'activity-logs',
  CUSTOMER_SETTINGS: 'customer-settings',
} as const;
